export default {
  isMenuOpen: false,
};
